import * as React from 'react';
import styled from '@emotion/styled';

const LinkButtonStyles = styled.a`
  color: #33322f;
  border-bottom: 1.5px solid #33322f;
  cursor: pointer;
  text-decoration: none;
  :hover{
    color:#BCC2C7;
    border-bottom: 1.5px solid #BCC2C7;
  }
`;

interface Props {
  linkText?: string;
  href?: string;
}
const LinkButton = (props: Props) => {
  return <LinkButtonStyles href={props.href}>{props.linkText}</LinkButtonStyles>;
};

export default LinkButton;
